<template>
  <div class="greet-job-page">
    <div class="job-page-content">
      <header class="page-heading">
        <div>
          <h1 class="page-title">选择打招呼的职位</h1>
          <p class="page-desc">选择一个或多个职位，开始智能招呼、复聊或搜索候选人。</p>
        </div>
        <button class="add-btn" @click="addJob">
          <i class="el-icon-plus" /> 添加新职位
        </button>
      </header>
      <div class="greet-box">
        <div class="greet-left">
          <div class="source-tabs" role="tablist" aria-label="候选人来源">
            <button class="nav-btn" :class="{ active: currentTab === 'recommend' }" role="tab"
              :aria-selected="currentTab === 'recommend'" @click="currentTab = 'recommend'">推荐</button>
            <button class="nav-btn new-cattle" :class="{ active: currentTab === 'newCattle' }" role="tab"
              :aria-selected="currentTab === 'newCattle'" @click="currentTab = 'newCattle'">新牛人</button>
          </div>
          <div class="toolbar-actions">
            <button class="action-btn primary-action" @click="GreetCall"><i class="el-icon-chat-dot-round" />
              开始打招呼</button>
            <button class="action-btn" @click="AgainCall"><i class="el-icon-refresh" /> 开始复聊</button>
            <el-dropdown @command="handleSearchCommand" trigger="click">
              <button class="action-btn">
                <i class="el-icon-search" /> 开始搜索 <i class="el-icon-arrow-down el-icon--right"></i>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="default">默认城市</el-dropdown-item>
                <el-dropdown-item command="national">全国</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <button class="action-btn" @click="autoReply"><i class="el-icon-chat-line-round" /> 自动回复</button>
          </div>
        </div>
      </div>
      <section class="jobs-panel" aria-label="职位列表">
        <div class="list-heading">
          <div>
            <h2>职位列表</h2>
            <span class="list-hint">拖动职位卡片可调整执行顺序</span>
          </div>
          <div class="list-heading-tools">
            <label class="job-search">
              <i class="el-icon-search" />
              <input v-model.trim="searchKeyword" type="text" placeholder="搜索职位名称，回车查询" aria-label="搜索职位名称"
                @keyup.enter="applyJobSearch" />
              <button v-if="searchKeyword" type="button" class="clear-search" aria-label="清空搜索"
                @click="clearJobSearch"><i class="el-icon-close" /></button>
            </label>
            <div class="list-count"><strong>{{ filteredPositionCount }}</strong><span v-if="appliedSearch"> / {{
              positionList.length }}</span> 个职位<span v-if="selectedPositions.length"> ·
                已选 {{ selectedPositions.length }}</span></div>
          </div>
        </div>
        <div class="position-list">
          <draggable v-model="positionList" animation="300" handle=".position-item" @end="handleDragEnd"
            ghost-class="sortable-ghost" drag-class="sortable-drag">
            <div class="position-item" v-for="(item, index) in positionList" :key="item.id"
              v-show="matchesJobSearch(item)" :class="{ active: item.isChecked }" @click="activeHover(index, item.id)"
              role="button" tabindex="0" @keyup.enter="activeHover(index, item.id)">
              <div class="item-box">
                <label class="cyberpunk-checkbox-label">
                  <input type="checkbox" class="cyberpunk-checkbox" v-model="item.isChecked"
                    @change.stop="handleCheckboxChange(item)">
                </label>
                <div class="position-info">
                  <span class="position-name">{{ item.positionName }}<span class="position-city">{{ item.positionCity
                      }}</span></span>
                  <div class="meta-info">
                    <span><i class="el-icon-chat-dot-round" /> 招呼 {{ item.recruitNum == 0 ? '不限' : item.recruitNum
                    }}</span>
                    <span><i class="el-icon-check" /> 已打 {{ item.overNum || 0 }}</span>
                    <span><i class="el-icon-key" /> 关键词 {{ item.recruitKey | tokeywordCount }}</span>
                    <span><i class="el-icon-circle-check" /> 目标 {{ item.containsCom | tombCount }}</span>
                    <span><i class="el-icon-remove-outline" /> 过滤 {{ item.filterCom | tofilterCount }}</span>
                  </div>
                </div>
              </div>
              <div class="action-btns">
                <button class="icon-action top-btn" @click.stop="handleTop(index)" title="置顶">
                  <i class="el-icon-top" />
                </button>
                <button class="text-action" @click.stop="handleEdit(item.id)"><i class="el-icon-edit-outline" />
                  编辑</button>
                <button class="text-action danger-action" @click.stop="handleDelete(item.id, index)"><i
                    class="el-icon-delete" /> 删除</button>
              </div>
            </div>
          </draggable>
          <div v-if="positionList.length && filteredPositionCount === 0" class="empty-state">
            <span class="empty-icon"><i class="el-icon-search" /></span>
            <strong>没有找到匹配的职位</strong>
            <p>试试职位名称中的其他关键词</p>
            <button class="add-btn" @click="clearJobSearch">清除搜索</button>
          </div>
          <div v-else-if="!positionList.length" class="empty-state">
            <span class="empty-icon"><i class="el-icon-suitcase" /></span>
            <strong>还没有职位</strong>
            <p>添加职位后即可开始智能招呼与候选人搜索</p>
            <button class="add-btn" @click="addJob"><i class="el-icon-plus" /> 添加新职位</button>
          </div>
        </div>
      </section>
    </div>
    <EditJob v-if="showEdit" :jobID="jobID" :name="name" @MessageClose="MessageClose" @AddClose="AddClose"
      @EditClose="EditClose"></EditJob>
  </div>
</template>

<script>
import EditJob from "@/views/BOSS/EditJob.vue";
import Draggable from 'vuedraggable';
import { getJobList, delectJob, getJobInfo, BSsetJobIndex, setHijackData } from "@/request/api";
import { getBossTaskStatus, startBossTask } from '@/utils/bossTask'
import { appendPendingLogEntry } from '@/utils/pendingLog'
export default {
  components: { EditJob, Draggable },
  filters: {
    tokeywordCount(val) {
      if (val !== undefined && val !== '') {
        if (val?.includes(',')) {
          return val.split(',').length;
        }
        return '1';
      }
      return '0';
    },
    tombCount(val) {
      if (val !== undefined && val !== '') {
        if (val?.includes(',')) {
          return val.split(',').length;
        }
        return '1';
      }
      return '0';
    },
    tofilterCount(val) {
      if (val !== undefined && val !== '') {
        if (val?.includes(',')) {
          return val.split(',').length;
        }
        return '1';
      }
      return '0';
    }
  },
  created() {
    if (sessionStorage.getItem("LoginInfo")) {
      this.username = JSON.parse(sessionStorage.getItem("LoginInfo")).username;
      this.getJob();
    }
  },
  data() {
    return {
      currentTab: 'recommend',
      searchKeyword: '',
      appliedSearch: '',
      username: '',
      clickIndex: null,
      positionList: [],
      curr: '',
      name: '',
      jobID: '',
      showEdit: false,
      taskStarting: false,
      selectedPositions: [],
      newArr: {
        id: '',
        userID: '',
        positionName: '',
        jobName: '',
        recruitNum: '',
        recruitScore: '',
        recruitKey: '',
        minAge: '',
        maxAge: '',
        gender: '',
        exchange: '',
        recentLook: '',
        jobHopping: '',
        eduRequire: '',
        activeCondi: '',
        collegeRequire: [],
        jobIntention: '',
        minSalary: '',
        maxSalary: '',
        containsCom: '',
        filterCom: '',
        greetDesc: '',
        recruitDesc: '',
        greetType: ''
      }
    }
  },
  computed: {
    filteredPositionCount() {
      return this.positionList.filter(item => this.matchesJobSearch(item)).length
    }
  },
  methods: {
    applyJobSearch() {
      this.appliedSearch = this.searchKeyword.trim()
    },
    clearJobSearch() {
      this.searchKeyword = ''
      this.appliedSearch = ''
    },
    matchesJobSearch(item) {
      if (!this.appliedSearch) return true
      return String(item.positionName || '').toLocaleLowerCase()
        .includes(this.appliedSearch.toLocaleLowerCase())
    },
    async handleDragEnd() {
      const { data: res } = await BSsetJobIndex({ username: this.username, jobList: this.positionList })
      // 这里建议调用后端接口保存排序后的 id 列表，否则刷新页面后顺序会还原
      // this.saveNewOrder(this.positionList.map(item => item.id));
    },
    handleSearchCommand(command) {
      this.searchCall(command)
    },
    ensureTaskAvailable() {
      const runningTask = getBossTaskStatus()
      if (runningTask) {
        this.$message.warning(`BOSS 正在执行${runningTask.type}，请结束当前任务后再启动其他功能`)
        return false
      }
      if (this.taskStarting) {
        this.$message.warning('功能正在准备中，请稍候')
        return false
      }
      return true
    },
    async autoReply() {
      if (!this.ensureTaskAvailable()) return
      if (this.clickIndex == null) {
        this.$message.warning('请先选择职位');
        return;
      }
      // sessionStorage.setItem('BtnType', '自动回复')
      startBossTask('自动回复')
      // 通过 sessionStorage 将本次启动事件交给日志页，避免页面切换时丢失。
      const now = new Date();
      const pad = value => String(value).padStart(2, '0');
      const startLog = {
        source: '系统事件',
        time: `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`,
        content: '启动BOSS自动回复功能，等待AI助手执行'
      };
      await setHijackData({ data: '', BtnType: '自动回复', channel: 'BOSS' });
      appendPendingLogEntry(startLog)
      this.$router.push({ path: '/log' });
    },
    async getJob() {
      this.positionList = [];
      const { data: res } = await getJobList({ username: this.username });
      this.positionList = res.data;
    },
    MessageClose() {
      this.showEdit = false;
    },
    AddClose() {
      this.showEdit = false;
      this.positionList = [];
      // this.$message.success('添加成功！');
      this.getJob();
    },
    EditClose() {
      this.showEdit = false;
      this.positionList = [];
      this.$message.success('修改成功！');
      this.getJob();
    },
    activeHover(index, itemId) {
      this.clickIndex = index;
      this.jobID = itemId;
      const currentItem = this.positionList[index];
      currentItem.isChecked = !currentItem.isChecked;
      this.positionList = [...this.positionList];
      this.handleCheckboxChange(currentItem);
    },
    handleCheckboxChange(item) {
      if (item.isChecked) {
        // 如果选中，添加到选中数组（避免重复添加）
        const isAlreadyAdded = this.selectedPositions.some(pos => pos.id === item.id);
        if (!isAlreadyAdded) {
          this.selectedPositions.push(item);
        }
      } else {
        // 如果取消选中，从数组中移除
        this.selectedPositions = this.selectedPositions.filter(pos => pos.id !== item.id);
      }
    },
    addJob() {
      this.showEdit = true;
      this.name = 'Add';
      this.jobID = 0;
    },
    async GreetCall() {
      if (!this.ensureTaskAvailable()) return
      this.taskStarting = true
      try {
        await this.executeGreetCall()
      } finally {
        this.taskStarting = false
      }
    },
    async executeGreetCall() {
      sessionStorage.removeItem('greetInfoList');
      // 处理选中的多个职位
      const formattedGreetList = [];
      if (this.clickIndex == null) {
        this.$message.warning('请先选择职位');
        return;
      }
      // 遍历所有选中的职位
      for (const position of this.selectedPositions) {
        // 获取当前职位的详细信息
        const { data: res } = await getJobInfo({
          username: this.username,
          jobID: position.id
        });
        var collegeRequire = res.data.collegeRequire;
        if (collegeRequire && collegeRequire.indexOf(',') !== -1) {
          collegeRequire = collegeRequire.split(',');
          const replaceMap = {
            "各国名校": "国内外名校",
            "双一流": "双一流院校"
          };
          collegeRequire = collegeRequire.reduce((acc, item) => {
            acc.push(replaceMap[item] || item);
            return acc;
          }, []);
        } else {
          const replaceMap = {
            "各国名校": "国内外名校",
            "双一流": "双一流院校"
          };
          collegeRequire = [replaceMap[collegeRequire] || collegeRequire];
        }
        var eduRequire = res.data.eduRequire;
        if (eduRequire && eduRequire.indexOf(',') !== -1) {
          eduRequire = eduRequire.split(',');
          const replaceMap = {
            "中专": "中专/中技",
          };
          eduRequire = eduRequire.reduce((acc, item) => {
            acc.push(replaceMap[item] || item);
            return acc;
          }, []);
        } else {
          const replaceMap = {
            "中专": "中专/中技",
          };
          eduRequire = [replaceMap[eduRequire] || eduRequire];
        }
        // 转换格式（与原有单个职位处理逻辑一致）
        const formattedItem = {
          id: res.data.id,
          userID: res.data.userID,
          positionName: res.data.positionName,
          positionCity: res.data.positionCity,
          jobName: res.data.jobName,
          wantJobName: res.data.wantJobName,
          recruitNum: res.data.recruitNum === 0 ? '不限' : res.data.recruitNum,
          recruitScore: res.data.recruitScore,
          recruitKey: res.data.recruitKey,
          recruitMajor: res.data.recruitMajor,
          minAge: res.data.minAge,
          maxAge: res.data.maxAge,
          mismatchScore: res.data.mismatchScore,
          keyType: res.data.keyType,
          resumeType: res.data.resumeType,
          MajorType: res.data.majorType,
          expertKey: res.data.expertKey,
          gender: res.data.gender === 0 ? '女' : res.data.gender === 1 ? '男' : '不限',
          exchange: res.data.exchange === 0 ? '不限' : '近一个月没有',
          recentLook: res.data.recentLook === 0 ? '不限' : '近14天没有',
          jobHopping: res.data.jobHopping === 0 ? '不限' :
            res.data.jobHopping === 1 ? '5年少于3份' : '平均每份工作大于1年',
          activeCondi: res.data.activeCondi === 0 ? '不限' :
            res.data.activeCondi === 1 ? '刚刚活跃' :
              res.data.activeCondi === 2 ? '今日活跃' :
                res.data.activeCondi === 3 ? '3日内活跃' :
                  res.data.activeCondi === 4 ? '本周活跃' : '本月活跃',
          collegeRequire: collegeRequire,
          eduRequire: eduRequire,
          expRequire: res.data.expRequire,
          jobIntention: res.data.jobIntention === 0 ? '不限' :
            res.data.jobIntention === 1 ? '离职-随时到岗' :
              res.data.jobIntention === 2 ? '在职-暂不考虑' :
                res.data.jobIntention === 3 ? '在职-考虑机会' : '在职-月内到岗',
          firstDegree: res.data.firstDegree,
          greetType: this.currentTab === 'recommend' ? '1' : '2',
          minSalary: res.data.minSalary,
          maxSalary: res.data.maxSalary,
          Chatted: res.data.chatted,
          confirmAddress: res.data.confirmAddress,
          onLineGreet: res.data.onLineGreet,
          localPeople: res.data.localPeople,
          segmented: res.data.segmented,
          containsCom: res.data.containsCom,
          filterCom: res.data.filterCom,
          greetDesc: res.data.greetDesc,
          recruitDesc: res.data.recruitDesc,
          GreetstartTime: res.data.GreetstartTime,
          GreetendTime: res.data.GreetendTime,
        };

        // 添加到新数组
        formattedGreetList.push(formattedItem);
      }

      // 如果没有选中任何职位，使用第一个职位（保持原有逻辑）
      if (formattedGreetList.length === 0) {
        const defaultJobId = this.jobID || this.positionList[0]?.id;
        if (defaultJobId) {
          const { data: res } = await getJobInfo({
            username: this.username,
            jobID: defaultJobId
          });
          // 这里是原有单个职位的转换逻辑，与上面格式一致
          // ...（省略重复代码）
          formattedGreetList.push(formattedItem);
        } else {
          this.$message.warning('请先选择职位');
          return;
        }
      }
      // 存储转换后的数组
      await setHijackData({ data: formattedGreetList, BtnType: '打招呼', channel: 'BOSS' });
      startBossTask('打招呼');

      // 通过 sessionStorage 将本次启动事件交给日志页，避免页面切换时丢失。
      const now = new Date();
      const pad = value => String(value).padStart(2, '0');
      const startLog = {
        source: '系统事件',
        time: `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`,
        content: '启动BOSS打招呼功能，等待AI助手执行'
      };
      appendPendingLogEntry(startLog)
      this.$router.push('/log');
    },
    async searchCall(command) {
      if (!this.ensureTaskAvailable()) return
      this.taskStarting = true
      try {
        await this.executeSearchCall(command)
      } finally {
        this.taskStarting = false
      }
    },
    async executeSearchCall(command) {
      // 处理选中的多个职位
      const formattedGreetList = [];
      if (this.clickIndex == null) {
        this.$message.warning('请先选择职位');
        return;
      }
      // 遍历所有选中的职位
      for (const position of this.selectedPositions) {
        // 获取当前职位的详细信息
        const { data: res } = await getJobInfo({
          username: this.username,
          jobID: position.id
        });
        var collegeRequire = res.data.collegeRequire;
        if (collegeRequire && collegeRequire.indexOf(',') !== -1) {
          collegeRequire = collegeRequire.split(',');
          const replaceMap = {
            "公办本科": "统招本科",
            "211": "211院校",
            "985": "985院校",
            "留学": "留学生",
            "双一流": "双一流院校"
          };
          collegeRequire = collegeRequire.reduce((acc, item) => {
            acc.push(replaceMap[item] || item);
            return acc;
          }, []);
        } else {
          const replaceMap = {
            "公办本科": "统招本科",
            "211": "211院校",
            "985": "985院校",
            "留学": "留学生",
            "双一流": "双一流院校"
          };
          collegeRequire = [replaceMap[collegeRequire] || collegeRequire];
        }
        // 转换格式（与原有单个职位处理逻辑一致）
        var newEduRequire = res.data.eduRequire?.includes(',')
          ? res.data.eduRequire.split(',')
          : [res.data.eduRequire];

        const formattedItem = {
          id: res.data.id,
          userID: res.data.userID,
          positionName: res.data.positionName,
          positionCity: res.data.positionCity,
          jobName: res.data.jobName,
          wantJobName: res.data.wantJobName,
          recruitNum: res.data.recruitNum === 0 ? '不限' : res.data.recruitNum,
          recruitScore: res.data.recruitScore,
          recruitKey: res.data.recruitKey,
          recruitMajor: res.data.recruitMajor,
          minAge: res.data.minAge,
          maxAge: res.data.maxAge,
          gender: res.data.gender === 0 ? '女' : res.data.gender === 1 ? '男' : '不限',
          exchange: res.data.exchange === 0 ? '不限' : '近30天未和同事交换简历',
          recentLook: res.data.recentLook === 0 ? '不限' : '过滤近14天查看',
          jobHopping: res.data.jobHopping === 0 ? '不限' :
            res.data.jobHopping === 1 ? '5年少于3份' : '时间≥1年',

          eduRequire: newEduRequire[0] === '大专' ? ['不限'] :
            newEduRequire[0] === '本科' ? ['本科及以上'] :
              newEduRequire[0] === '硕士' ? ['硕士及以上'] :
                newEduRequire[0] === '博士' ? ['博士'] : ['不限'],

          activeCondi: res.data.activeCondi === 0 ? '不限' :
            res.data.activeCondi === 1 ? '刚刚活跃' :
              res.data.activeCondi === 2 ? '今日活跃' :
                res.data.activeCondi === 3 ? '3日内活跃' :
                  res.data.activeCondi === 4 ? '近一周活跃' : '近一个月活跃',
          collegeRequire: collegeRequire,
          expRequire: res.data.expRequire,
          jobIntention: res.data.jobIntention === 0 ? '不限' :
            res.data.jobIntention === 1 ? '离职-随时到岗' :
              res.data.jobIntention === 2 ? '在职-暂不考虑' :
                res.data.jobIntention === 3 ? '在职-考虑机会' : '在职-月内到岗',
          greetType: this.currentTab === 'recommend' ? '1' : '2',
          keyType: res.data.keyType,
          resumeType: res.data.resumeType,
          MajorType: res.data.majorType,
          confirmAddress: res.data.confirmAddress,
          minSalary: res.data.minSalary,
          maxSalary: res.data.maxSalary,
          Chatted: res.data.chatted,
          onLineGreet: res.data.onLineGreet,
          containsCom: res.data.containsCom,
          filterCom: res.data.filterCom,
          greetDesc: res.data.greetDesc,
          recruitDesc: res.data.recruitDesc
        };
        // 添加到新数组
        formattedGreetList.push(formattedItem);
      }

      // 如果没有选中任何职位，使用第一个职位（保持原有逻辑）
      if (formattedGreetList.length === 0) {
        const defaultJobId = this.jobID || this.positionList[0]?.id;
        if (defaultJobId) {
          const { data: res } = await getJobInfo({
            username: this.username,
            jobID: defaultJobId
          });
          // 这里是原有单个职位的转换逻辑，与上面格式一致
          // ...（省略重复代码）
          formattedGreetList.push(formattedItem);
        } else {
          this.$message.warning('请先选择职位');
          return;
        }
      }
      if (command === 'default') {
        await setHijackData({ data: formattedGreetList, BtnType: '搜索', channel: 'BOSS', city: '默认' });
      } else {
        await setHijackData({ data: formattedGreetList, BtnType: '搜索', channel: 'BOSS', city: '全国' });
      }
      // 存储转换后的数组
      startBossTask('搜索');
      // 通过 sessionStorage 将本次启动事件交给日志页，避免页面切换时丢失。
      const now = new Date();
      const pad = value => String(value).padStart(2, '0');
      const startLog = {
        source: '系统事件',
        time: `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`,
        content: '启动BOSS搜索功能，等待AI助手执行'
      };
      appendPendingLogEntry(startLog)
      // 可以根据需要跳转到其他页面
      this.$router.push('/log');
    },

    async AgainCall() {
      if (!this.ensureTaskAvailable()) return
      this.taskStarting = true
      try {
        await this.executeAgainCall()
      } finally {
        this.taskStarting = false
      }
    },

    async executeAgainCall() {
      // 处理选中的多个职位
      const formattedGreetList = [];
      if (this.clickIndex == null) {
        this.$message.warning('请先选择职位');
        return;
      }
      // 遍历所有选中的职位
      for (const position of this.selectedPositions) {
        const { data: res } = await getJobInfo({
          username: this.username,
          jobID: position.id
        });
        // 转换格式（与原有单个职位处理逻辑一致）
        const formattedItem = {
          jobID: position.id,
          positionName: position.positionName,
          positionCity: position.positionCity,
          flStartTime: res.data.flstartTime,
          flstartDate: res.data.flstartDate,
          flEndTime: res.data.flendTime
        };
        // 添加到新数组
        formattedGreetList.push(formattedItem);
      }
      // 存储转换后的数组
      await setHijackData({ data: formattedGreetList, BtnType: '复聊', channel: 'BOSS' });
      startBossTask('复聊')
      // 通过 sessionStorage 将本次启动事件交给日志页，避免页面切换时丢失。
      const now = new Date();
      const pad = value => String(value).padStart(2, '0');
      const startLog = {
        source: '系统事件',
        time: `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`,
        content: '启动BOSS复聊功能，等待AI助手执行'
      };
      appendPendingLogEntry(startLog)
      // 可以根据需要跳转到其他页面
      this.$router.push('/log');
    },
    handleTop(index) {
      // 置顶职位逻辑
      if (index === 0) {
        this.$message.info('该职位已经在顶部');
        return;
      }
      const item = this.positionList.splice(index, 1)[0];
      this.positionList.unshift(item);
      // 更新选中状态
      if (this.clickIndex === index) {
        this.clickIndex = 0;
      } else if (this.clickIndex < index) {
        this.clickIndex++;
      }
      // 调用后端保存排序
      BSsetJobIndex({ username: this.username, jobList: this.positionList });
      this.$message.success('置顶成功');
    },
    handleEdit(id) {
      // 编辑职位逻辑
      this.showEdit = true;
      this.name = 'Edit'
      this.jobID = id;
    },
    async handleDelete(id, index) {
      // 删除职位逻辑，比如提示确认后删除
      if (window.confirm('确定删除该职位吗？')) {
        await delectJob({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: id });
        this.positionList.splice(index, 1);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.greet-job-page {
  min-height: 100%;
  max-width: 960px;
  padding: 8px 4px 20px;
  color: var(--text-primary);
  user-select: none;
  margin: 0 auto;
}

.job-page-content {
  width: min(100%, 1280px);
  margin: 0 auto;
}

.page-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 22px;

  .eyebrow {
    margin-bottom: 7px;
    color: var(--brand);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .04em;
  }

  .page-title {
    margin: 0;
    color: var(--text-primary);
    font-size: 25px;
    font-weight: 700;
    letter-spacing: -.3px;
  }

  .page-desc {
    margin-top: 7px;
    color: var(--text-secondary);
    font-size: 13px;
    line-height: 1.6;
  }
}

.greet-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
  padding: 12px 14px;
  border: 1px solid var(--border-hairline);
  border-radius: $radius-lg;
  background: var(--bg-card);
  box-shadow: var(--shadow-card);
}

.greet-left,
.toolbar-actions,
.source-tabs {
  display: flex;
  align-items: center;
}

.greet-left {
  gap: 14px;
  min-width: 0;
}

.toolbar-actions {
  flex-wrap: wrap;
  gap: 8px;
}

.source-tabs {
  flex-shrink: 0;
  gap: 3px;
  padding: 3px;
  border: 1px solid var(--border-hairline);
  border-radius: 9px;
  background: var(--bg-page);

  .nav-btn {
    min-height: 32px;
    padding: 0 13px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: var(--text-secondary);
    font: inherit;
    font-size: 13px;
    cursor: pointer;
    transition: color .18s ease, background-color .18s ease, box-shadow .18s ease;

    &:hover {
      color: var(--text-primary);
    }

    &.active {
      background: var(--bg-card);
      color: var(--brand);
      font-weight: 600;
      box-shadow: var(--shadow-card);
    }
  }
}

.action-btn,
.add-btn,
.text-action,
.icon-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid var(--border-hairline);
  border-radius: 7px;
  color: var(--text-regular);
  background: var(--bg-card);
  font: inherit;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
  transition: color .18s ease, background-color .18s ease, border-color .18s ease, transform .18s ease, box-shadow .18s ease;

  &:focus-visible {
    outline: 2px solid var(--brand);
    outline-offset: 2px;
  }
}

.action-btn {
  min-height: 34px;
  padding: 0 11px;

  &:hover {
    color: var(--brand);
    border-color: var(--brand-glow);
    background: var(--bg-active);
  }
}

.primary-action,
.add-btn {
  border-color: var(--brand);
  background: var(--brand);
  color: var(--on-brand);

  &:hover {
    border-color: var(--brand-hover);
    background: var(--brand-hover);
    color: var(--on-brand);
    box-shadow: 0 4px 12px var(--brand-glow);
  }
}

.add-btn {
  min-height: 36px;
  padding: 0 14px;
  font-size: 13px;
}

.jobs-panel {
  overflow: hidden;
  border: 1px solid var(--border-hairline);
  border-radius: $radius-lg;
  background: var(--bg-card);
  box-shadow: var(--shadow-card);
}

.list-heading {
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 18px;
  border-bottom: 1px solid var(--divider);

  h2 {
    margin: 0;
    color: var(--text-primary);
    font-size: 14px;
    font-weight: 600;
  }

  .list-hint {
    display: block;
    margin-top: 4px;
    color: var(--text-secondary);
    font-size: 11px;
  }

  .list-count {
    color: var(--text-secondary);
    font-size: 12px;
    white-space: nowrap;
  }

  .list-count strong {
    color: var(--text-primary);
    font-size: 14px;
  }
}

.list-heading-tools {
  display: flex;
  align-items: center;
  gap: 14px;
}

.job-search {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 260px;
  height: 36px;
  padding: 0 10px;
  border: 1px solid var(--border-hairline);
  border-radius: 8px;
  background: var(--bg-page);
  color: var(--text-secondary);
  transition: border-color .16s ease, box-shadow .16s ease;

  &:focus-within {
    border-color: var(--brand);
    box-shadow: 0 0 0 3px var(--brand-glow);
  }

  >i {
    flex-shrink: 0;
    color: var(--brand);
  }

  input {
    flex: 1;
    min-width: 0;
    height: 100%;
    border: 0;
    outline: 0;
    background: transparent;
    color: var(--text-primary);
    font: inherit;
    font-size: 12px;
  }

  input::placeholder {
    color: var(--text-disabled);
  }

  .clear-search {
    display: grid;
    place-items: center;
    width: 22px;
    height: 22px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: var(--text-secondary);
    cursor: pointer;
  }

  .clear-search:hover {
    background: var(--bg-hover);
    color: var(--text-primary);
  }
}

.position-list {
  max-height: calc(100vh - 310px);
  min-height: 190px;
  overflow: auto;
  padding: 10px;
  scrollbar-width: thin;
  scrollbar-color: var(--border-hairline) transparent;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background: var(--border-hairline);
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--text-secondary);
  }
}

.position-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  min-height: 76px;
  margin-bottom: 8px;
  padding: 13px 14px;
  border: 1px solid var(--border-hairline);
  border-radius: 10px;
  background: var(--bg-card);
  cursor: pointer;
  transition: background-color .18s ease, border-color .18s ease, box-shadow .18s ease, transform .18s ease;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    border-color: var(--brand-glow);
    background: var(--bg-hover);
  }

  &:focus-visible {
    outline: 2px solid var(--brand);
    outline-offset: 2px;
  }

  &.active {
    border-color: var(--brand-glow);
    background: var(--bg-active);
    box-shadow: inset 3px 0 0 var(--brand);
  }

  .item-box {
    display: flex;
    align-items: center;
    min-width: 0;
    gap: 12px;
  }

  .cyberpunk-checkbox-label {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    cursor: pointer;
  }

  .cyberpunk-checkbox {
    appearance: none;
    width: 17px;
    height: 17px;
    margin: 0;
    border: 1.5px solid var(--text-disabled);
    border-radius: 5px;
    background: var(--bg-page);
    cursor: pointer;
    transition: background-color .15s ease, border-color .15s ease;

    &:checked {
      border-color: var(--brand);
      background: var(--brand);
    }

    &:checked::after {
      content: '';
      display: block;
      width: 4px;
      height: 8px;
      margin: 2px 5px;
      border: solid var(--on-brand);
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }

    &:focus-visible {
      outline: 2px solid var(--brand-glow);
      outline-offset: 2px;
    }
  }

  .position-info {
    min-width: 0;
  }

  .position-name {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    color: var(--text-primary);
    font-size: 14px;
    font-weight: 600;
  }

  .position-city {
    padding: 2px 7px;
    border-radius: 5px;
    background: var(--bg-page);
    color: var(--text-secondary);
    font-size: 11px;
    font-weight: 400;
  }

  .meta-info {
    display: flex;
    flex-wrap: wrap;
    gap: 7px 14px;
    margin-top: 8px;
    color: var(--text-secondary);
    font-size: 11px;
  }

  .meta-info span {
    white-space: nowrap;
  }

  .meta-info i {
    margin-right: 3px;
    color: var(--brand);
  }
}

.action-btns {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 5px;
}

.icon-action {
  width: 30px;
  height: 30px;
  padding: 0;
}

.icon-action:hover {
  color: var(--brand);
  border-color: var(--brand-glow);
  background: var(--bg-active);
}

.text-action {
  min-height: 30px;
  padding: 0 8px;
  border-color: transparent;
  background: transparent;
}

.text-action:hover {
  color: var(--brand);
  background: var(--bg-active);
}

.text-action.danger-action:hover {
  color: var(--danger);
  background: color-mix(in srgb, var(--danger) 10%, transparent);
}

.empty-state {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 46px 16px;
  color: var(--text-secondary);
  text-align: center;

  .empty-icon {
    display: grid;
    place-items: center;
    width: 48px;
    height: 48px;
    margin-bottom: 12px;
    border-radius: 14px;
    background: var(--brand-weak);
    color: var(--brand);
    font-size: 22px;
  }

  strong {
    color: var(--text-primary);
    font-size: 14px;
  }

  p {
    margin: 6px 0 16px;
    font-size: 12px;
  }
}

.sortable-ghost {
  opacity: .55;
  border: 1px dashed var(--brand);
  background: var(--bg-active) !important;
}

.sortable-drag {
  box-shadow: var(--shadow-pop);
}

@media (max-width: 900px) {
  .greet-left {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }

  .position-item {
    align-items: flex-start;
  }

  .position-list {
    max-height: calc(100vh - 340px);
  }
}

@media (max-width: 640px) {
  .greet-job-page {
    padding: 2px 0 12px;
  }

  .page-heading {
    align-items: flex-start;
    margin-bottom: 16px;
  }

  .page-heading .page-title {
    font-size: 21px;
  }

  .page-heading .page-desc {
    max-width: 280px;
  }

  .greet-box {
    align-items: stretch;
    padding: 10px;
  }

  .greet-left {
    width: 100%;
  }

  .toolbar-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }

  .toolbar-actions>*,
  .toolbar-actions .action-btn {
    width: 100%;
  }

  .list-heading {
    align-items: flex-start;
    flex-direction: column;
    padding: 12px;
  }

  .list-heading-tools {
    align-items: stretch;
    flex-direction: column;
    width: 100%;
    gap: 8px;
  }

  .job-search {
    box-sizing: border-box;
    width: 100%;
  }

  .list-heading-tools .list-count {
    text-align: right;
  }

  .list-heading .list-hint {
    max-width: 210px;
    line-height: 1.5;
  }

  .position-list {
    max-height: none;
    min-height: 150px;
    padding: 8px;
  }

  .position-item {
    flex-direction: column;
    gap: 12px;
    padding: 12px;
  }

  .position-item .item-box {
    width: 100%;
    align-items: flex-start;
  }

  .position-item .action-btns {
    width: 100%;
    justify-content: flex-end;
    border-top: 1px solid var(--divider);
    padding-top: 9px;
  }
}

@media (max-width: 420px) {
  .page-heading {
    gap: 8px;
  }

  .page-heading .page-title {
    font-size: 19px;
  }

  .page-heading .page-desc {
    font-size: 12px;
  }

  .page-heading .add-btn {
    min-height: 33px;
    padding: 0 9px;
    font-size: 11px;
  }

  .meta-info {
    gap: 6px 9px !important;
  }

  .list-heading .list-count {
    font-size: 11px;
  }
}
</style>
